import { showNotification } from 'containers/NotificationEngine/actions';
import {
  NOTIFICATION_TYPE_ERROR,
  NOTIFICATION_TYPE_SUCCESS,
  NOTIFICATION_TIMEOUT_NONE,
  NOTIFICATION_TIMEOUT_DEFAULT,
} from 'containers/NotificationEngine/constants';
import { saveInProgress, setForm, setDirty, updateFormValue } from 'containers/FormBuilder/actions';
import { updateForm as serverUpdateForm, cloneForm as serverCloneForm, getForm as serverGetForm } from 'api/taxi.backend';
import { publishForm as serverPublishForm, unpublishForm as serverUnpublishForm } from 'api/taxi.rest.backend';
import { hasInvalidFormState } from 'containers/FormBuilder/asyncutils';
import { getCredentialTypeIdFromUrl } from 'utils/redirects';
import { PUBLISHED_STATUS } from 'utils/constants';

export const handleSaveFormUpdate = async (form, dispatch) => {
  dispatch(saveInProgress(true));
  try {
    const invalidGraph = hasInvalidFormState(form);
    if (invalidGraph.isInvalid) {
      dispatch(showNotification(
        'taxi:graph-invalid',
        NOTIFICATION_TYPE_ERROR,
        invalidGraph.message,
        NOTIFICATION_TIMEOUT_NONE,
        null,
        null
      ));
    } else {
      const response = await serverUpdateForm(form);
      dispatch(setForm(response));
      dispatch(showNotification(
        'taxi:success-save-form',
        NOTIFICATION_TYPE_SUCCESS,
        'Saved',
        NOTIFICATION_TIMEOUT_DEFAULT,
        null,
        null
      ));
      dispatch(setDirty(false));
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
    dispatch(showNotification(
      'taxi:err-save-form',
      NOTIFICATION_TYPE_ERROR,
      'Save failed',
      NOTIFICATION_TIMEOUT_NONE,
      null,
      null
    ));
  }
  dispatch(saveInProgress(false));
};

export const handleCloneForm = async (formId, groupingId, options, dispatch) => {
  const credentialTypeId = getCredentialTypeIdFromUrl();
  try {
    const { cloneForm: { id: newId } } = await serverCloneForm(formId, options.shouldMakeExperimental);
    const url = new URL(`/credential-type/${credentialTypeId}/groupings/${groupingId}/forms/${newId}`, window.location);
    window.open(url);
    dispatch(showNotification(
      'taxi:success-clone-form',
      NOTIFICATION_TYPE_SUCCESS,
      'Cloned',
      NOTIFICATION_TIMEOUT_DEFAULT,
      null,
      null
    ));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
    dispatch(showNotification(
      'taxi:err-clone-form',
      NOTIFICATION_TYPE_ERROR,
      'Unable to Clone Form.',
      NOTIFICATION_TIMEOUT_NONE,
      null,
      null
    ));
  }
};

export const handlePublishForm = async (formId, date, dispatch) => {
  try {
    await serverPublishForm(formId);
    dispatch(updateFormValue(['isPublished'], true, false));
    dispatch(updateFormValue(['lastPublished'], date, false));
    dispatch(updateFormValue(['publishedStatus'], PUBLISHED_STATUS.PUBLISHED, false));
    dispatch(showNotification(
      'taxi:success-publish-form',
      NOTIFICATION_TYPE_SUCCESS,
      'Form Published',
      NOTIFICATION_TIMEOUT_DEFAULT,
      null,
      null
    ));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
    dispatch(showNotification(
      'taxi:err-publish-form',
      NOTIFICATION_TYPE_ERROR,
      'Publish failed',
      NOTIFICATION_TIMEOUT_NONE,
      null,
      null
    ));
  }
};

export const handleUnpublishForm = async (formId, dispatch) => {
  try {
    await serverUnpublishForm(formId);
    dispatch(updateFormValue(['isPublished'], false, false));
    dispatch(updateFormValue(['publishedStatus'], PUBLISHED_STATUS.UNPUBLISHED, false));
    dispatch(showNotification(
      'taxi:success-unpublish-form',
      NOTIFICATION_TYPE_SUCCESS,
      'Form Unpublished',
      NOTIFICATION_TIMEOUT_DEFAULT,
      null,
      null
    ));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
    dispatch(showNotification(
      'taxi:err-unpublish-form',
      NOTIFICATION_TYPE_ERROR,
      'Unpublish Failed',
      NOTIFICATION_TIMEOUT_NONE,
      null,
      null
    ));
  }
};

export const handleLoadForm = async (formId, fetchFieldData, dispatch) => {
  try {
    const response = await serverGetForm(formId);
    dispatch(setForm(response, { shouldRebuildCollapsedState: true }));
    dispatch(setDirty(false));

    fetchFieldData(response.salesforceOrg);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
    dispatch(showNotification(
      'taxi:err-load-form',
      NOTIFICATION_TYPE_ERROR,
      'Failed to load form',
      NOTIFICATION_TIMEOUT_NONE,
      null,
      null
    ));
  }
};
